<template>
  <component :is="sessionData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="sessionData === undefined">
      <h4 class="alert-heading">Error fetching session data</h4>
      <div class="alert-body">
        No session found with this session id. Check
        <b-link class="alert-link" :to="{ name: 'apps-roster-session-list' }"> Session List </b-link>
        for other sessions.
      </div>
    </b-alert>

    <b-tabs v-if="sessionData" pills>
      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Information</span>
        </template>
        <session-edit-tab-information :session-data.sync="sessionData" class="mt-2 pt-75" />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import rosterStoreModule from '../rosterStoreModule';
import SessionEditTabInformation from './SessionEditTabInformation.vue';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    SessionEditTabInformation,
  },
  setup() {
    const sessionData = ref(null);

    const SESSION_APP_STORE_MODULE_NAME = 'app-roster';

    // Register module
    if (!store.hasModule(SESSION_APP_STORE_MODULE_NAME))
      store.registerModule(SESSION_APP_STORE_MODULE_NAME, rosterStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SESSION_APP_STORE_MODULE_NAME)) store.unregisterModule(SESSION_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch('app-roster/fetchSession', { id: router.currentRoute.params.id })
      .then((response) => {
        sessionData.value = response.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          sessionData.value = undefined;
        }
      });

    return {
      sessionData,
    };
  },
};
</script>

<style></style>
